import { pink } from '@mui/material/colors';
import palette from '../theme/palette';

// ----------------------------------------------------------------------

export const colorPresets = [
  // DEFAULT
  {
    name: 'default',
    ...palette.light.primary,
  },
  // PURPLE
  {
    name: 'purple',
    lighter: '#EBD6FD',
    light: '#B985F4',
    main: '#7635dc',
    dark: '#431A9E',
    darker: '#200A69',
    contrastText: '#fff',
  },
  // CYAN
  {
    name: 'cyan',
    lighter: '#D1FFFC',
    light: '#76F2FF',
    main: '#1CCAFF',
    dark: '#0E77B7',
    darker: '#053D7A',
    contrastText: palette.light.grey[800],
  },
  // BLUE
  {
    name: 'blue',
    lighter: '#D1E9FC',
    light: '#76B0F1',
    main: '#2065D1',
    dark: '#103996',
    darker: '#061B64',
    contrastText: '#fff',
  },
  // ORANGE
  {
    name: 'orange',
    lighter: '#FEF4D4',
    light: '#FED680',
    main: '#FDA92D',
    dark: '#B66816',
    darker: '#793908',
    contrastText: palette.light.grey[800],
  },
  // RED
  {
    name: 'red',
    lighter: '#FFE3D5',
    light: '#FFC1AC',
    main: '#FF3030',
    dark: '#B71833',
    darker: '#7A0930',
    contrastText: '#fff',
  },
  // design by adex
  {
    name: 'adex_green',
    lighter: '#5cd3e0',
    light: '#33b3cc',
    main: '#02a9c8',
    dark: '#00778f',
    darker: '#004a55',
    contrastText: '#fff',
  },
  {
    name: 'brown',
    lighter: '#D19A6A',
    light: '#A65E2A',
    main: '#A52A2A',
    dark: '#7B1F1F',
    darker: '#4E0E0E',
    contrastText: '#fff',
  },
  {
    name: 'pink',
    lighter: '#FAD6E6',
    light: '#E95F91',
    main: '#AF1062',
    dark: '#76013E',
    darker: '#450122',
    contrastText: palette.light.grey[800],
  },
];

export const defaultPreset = colorPresets[0];
export const purplePreset = colorPresets[1];
export const cyanPreset = colorPresets[2];
export const bluePreset = colorPresets[3];
export const orangePreset = colorPresets[4];
export const redPreset = colorPresets[5];
export const adexgreenPreset = colorPresets[6];
export const tmbrown = colorPresets[7];
export const tmpink = colorPresets[8];

export default function getColorPresets(presetsKey) {
  return {
    purple: purplePreset,
    cyan: cyanPreset,
    blue: bluePreset,
    orange: orangePreset,
    red: redPreset,
    default: defaultPreset,
    adex_green: adexgreenPreset,
    brown: tmbrown,
    pink: tmpink,
  }[presetsKey];
}
